import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

/**
 * Каркас локализации. Язык один — английский, переключателя нет намеренно.
 *
 * `supportedLngs` держит список из одного языка: даже прямой вызов
 * `i18n.changeLanguage('uk')` будет отклонён и язык останется английским.
 * Это не защита от злоумышленника, а защита от случайного включения
 * половины переведённого интерфейса.
 *
 * Каталог подключён синхронно, а не через `i18next-http-backend`: страницы
 * рендерятся под `<Suspense>` без `fallback` (`renderRoute.tsx`), и асинхронная
 * загрузка дала бы белый экран вместо загрузчика.
 *
 * Провайдера нет и не нужно: `useTranslation` подписывается на смену языка сам,
 * а ресурсы уже в памяти. Как добавить язык — `docs/i18n.md`.
 */
export const resources = { en: { translation: en } };

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en'],
  resources,
  // React экранирует сам. Без этого флага апострофы и подстановки экранируются дважды.
  interpolation: { escapeValue: false },
});

// Язык документа держим в согласии с языком интерфейса. Сегодня это en в обе стороны,
// но без этой связки документ со вторым языком нарушит WCAG 3.1.1, и ни один
// автоматический прогон по английской сборке этого не покажет.
const syncDocumentLang = () => {
  document.documentElement.lang = i18n.language;
};

syncDocumentLang();
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
